<div class="bank-link">
  <img src="../../../../assets/img/solde_insuffisant.png" alt="image" />
  <h3 class="bank-link__title">
    {{ "MODALS.BANK_ACCOUNT.TITLE" | translate }}
  </h3>
  <p class="bank-link__message">
    {{ "MODALS.BANK_ACCOUNT.MESSAGE" | translate }}
  </p>
  <div class="bank-link__buttons">
    <app-button
      [loading]="isLoading"
      [disabled]="isLoading"
      (onClick)="getActivateBankLink()"
      [innerText]="'MODALS.BANK_ACCOUNT.CREATE_ACCOUNT' | translate"
    />
    <app-button
      [styles]="{ backgroundColor: '#1D5D9B80' }"
      (onClick)="closeModal()"
      [innerText]="'MODALS.BANK_ACCOUNT.NOT_NOW' | translate"
    />
  </div>
</div>
